import { gql } from 'urql';

const UpdateNotificationPreferences = gql`
  mutation UpdateNotificationPreferences(
    $input: UpdateNotificationPreferenceChannelInput!
  ) {
    updateNotificationPreferenceChannel(input: $input) {
      __typename
      ... on UpdateNotificationPreferenceChannelSuccess {
        myNotificationPreferences {
          forWeb {
            name
            description
            channels {
              id
              name
              enabled
            }
          }
          forMobile {
            name
            description
            channels {
              id
              name
              enabled
            }
          }
        }
      }
      ... on UpdateNotificationPreferenceChannelError {
        code
        title
        message
      }
    }
  }
`;

export default UpdateNotificationPreferences;
